import vue from "vue";
const Pagination = () => import(/* webpackPrefetch: true */'./Pagination.vue')

vue.component("Pagination", Pagination);